module.exports = __webpack_public_path__ + "img/photo-contact.28ec008.jpg";